// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fffcad87","732":"928f54b2","977":"89d91e64"}[chunkId] + ".chunk.js";
};